import { render } from "./SocialTelegram.vue?vue&type=template&id=0771c206"
import script from "./SocialTelegram.vue?vue&type=script&lang=js"
export * from "./SocialTelegram.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__